declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

const PIXEL_ID = '2134630104036378'

let initialized = false

export function initPixel() {
  if (initialized) return
  initialized = true

  const f = window as any
  const b = document
  const e = 'script'
  const v = 'https://connect.facebook.net/en_US/fbevents.js'

  if (f.fbq) return

  const n: any = (f.fbq = function (...args: unknown[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as unknown[][]

  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = v
  const s = b.getElementsByTagName(e)[0]
  s?.parentNode?.insertBefore(t, s)

  window.fbq('init', PIXEL_ID)
}

export function trackPageView() {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Cadenas Rotas',
      content_type: 'product',
      value: 8.49,
      currency: 'USD',
    })
  }
}
